<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            :class="
              rowData.fatura_despesa_doc.length > 0
                ? 'nav-link active'
                : 'nav-link'
            "
            v-bind:href="'#t1' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.fatura_despesa_doc.length > 0"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              showShipmenteDocService
                ? 'nav-link active'
                : 'nav-link'
            "
            v-bind:href="'#t2' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="showShipmenteDocService"
          >
            <span class="nav-link-in">
              Notas Fiscais
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              !(rowData.fatura_despesa_doc.length > 0) &&
              !showShipmenteDocService &&
              rowData.fatura_despesa_trecho.length > 0
                ? 'nav-link active'
                : 'nav-link'
            "
            v-bind:href="'#t3' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.fatura_despesa_trecho.length > 0"
          >
            <span class="nav-link-in">
              Trechos
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              !(rowData.fatura_despesa_doc.length > 0) &&
              !showShipmenteDocService &&
              !(rowData.fatura_despesa_trecho.length > 0) &&
              rowData.obs != null
                ? 'nav-link active'
                : 'nav-link'
            "
            v-bind:href="'#t4' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.obs != null"
          >
            <span class="nav-link-in">
              Justificativa
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              !(rowData.fatura_despesa_doc.length > 0) &&
              !showShipmenteDocService &&
              !(rowData.fatura_despesa_trecho.length > 0) &&
              !(rowData.obs != null) &&
              rowData.num_fatura_erp != null
                ? 'nav-link active'
                : 'nav-link'
            "
            class="nav-link active"
            v-bind:href="'#t5' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.num_fatura_erp != null"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              !(rowData.fatura_despesa_doc.length > 0) &&
              !showShipmenteDocService &&
              !(rowData.fatura_despesa_trecho.length > 0) &&
              !(rowData.obs != null) &&
              !(rowData.num_fatura_erp != null) &&
              rowData.fatura_despesa_foto.length > 0
                ? 'nav-link active'
                : 'nav-link'
            "
            class="nav-link"
            v-bind:href="'#t6' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.fatura_despesa_foto.length > 0"
          >
            <span class="nav-link-in">
              Foto do Documento
              <i class="fa fa-picture-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="
              !(rowData.fatura_despesa_doc.length > 0) &&
              !showShipmenteDocService &&
              !(rowData.fatura_despesa_trecho.length > 0) &&
              !(rowData.obs != null) &&
              !(rowData.num_fatura_erp != null) &&
              !(rowData.fatura_despesa_foto.length > 0) &&
              rowData.motivo_rejeicao != null
                ? 'nav-link active'
                : 'nav-link'
            "
            class="nav-link"
            v-bind:href="'#t7' + rowData.fatdes_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.motivo_rejeicao != null"
          >
            <span class="nav-link-in">
              Motivo Rejeição Protheus
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          :class="
            rowData.fatura_despesa_doc.length > 0
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.fatdes_id + ''"
          v-if="rowData.fatura_despesa_doc.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Número Fiscal</th>
                <th style="width: 10%">Série</th>
                <th style="width: 15%">Data de emissão</th>
                <th style="width: 15%">Valor</th>
                <th style="width: 15%">Tipo do Documento</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.fatura_despesa_doc"
                :key="item.fatura_despesa_doc_id"
              >
                <td>
                  {{ item.doc_transp.num_doc }}
                </td>
                <td>
                  {{ item.doc_transp.serie }}
                </td>
                <td>
                  <span> {{ DateFormat(item.doc_transp.dt_emissao) }} </span>
                </td>
                <td>
                  {{ item.doc_transp.doc_transp_vlr_prestacao.vlr_receber }}
                </td>
                <td>
                  {{ item.doc_transp.liv_tp_doc.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          :class="
            showShipmenteDocService
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t2' + rowData.fatdes_id + ''"
          v-if="showShipmenteDocService"
        >
          <table class="table" id="carga-doc-servico">
            <thead>
              <tr>
                <th style="width: 10%">Número Fiscal</th>
                <th style="width: 10%">Série</th>
                <th style="width: 15%">Data de emissão</th>
                <th style="width: 15%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.carga_doc_servico"
                :key="item.carga_doc_servico_id"
              >
                <td>{{ item.doc_fiscal.num_fiscal }}</td>
                <td>{{ item.doc_fiscal.serie }}</td>
                <td>
                  <span>{{ DateFormat(rowData.dt_emi) }}</span>
                </td>
                <td>
                  <span v-if="item.doc_fiscal.carga_doc.pedido_unidade_carga_trecho_doc && item.doc_fiscal.carga_doc.pedido_unidade_carga_trecho_doc.length">
                    {{ item.doc_fiscal.carga_doc.pedido_unidade_carga_trecho_doc[0].total_vlr_frete }}
                  </span>
                  <span v-else>N/A</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          :class="
            !(rowData.fatura_despesa_doc.length > 0) &&
            !showShipmenteDocService &&
            rowData.fatura_despesa_trecho.length > 0
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t3' + rowData.fatdes_id + ''"
          v-if="rowData.fatura_despesa_trecho.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Trecho</th>
                <th style="width: 50%">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.fatura_despesa_trecho"
                :key="item.fatura_despesa_trecho_id"
              >
                <td>
                  {{ item.pedido_unidade_carga_trecho.num_trecho }}
                </td>
                <td>
                  {{ item.pedido_unidade_carga_trecho.vlr_custo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          :class="
            !(rowData.fatura_despesa_doc.length > 0) &&
            !(rowData.fatura_despesa_trecho.length > 0) &&
            !showShipmenteDocService &&
            rowData.obs != null
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t4' + rowData.fatdes_id + ''"
          v-if="rowData.obs != null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Justificativa</th>
                <th style="width: 50%">Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.obs != null">
                    {{ rowData.obs }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.tp_motivo != null">
                    {{ rowData.tp_motivo.descr }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          :class="
            !(rowData.fatura_despesa_doc.length > 0) &&
            !showShipmenteDocService &&
            !(rowData.fatura_despesa_trecho.length > 0) &&
            !(rowData.obs != null) &&
            rowData.num_fatura_erp != null
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t5' + rowData.fatdes_id + ''"
          v-if="rowData.num_fatura_erp != null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 25%">N° fatura ERP</th>
                <th style="width: 25%">Data Envio ERP</th>
                <th style="width: 25%">Previsão de Pagamento</th>
                <th style="width: 25%">Status ERP</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.num_fatura_erp != null">
                    {{ rowData.num_fatura_erp }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.num_fatura_erp != null">
                    {{ DateFormat(rowData.dt_integracao) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.dt_pagto_erp != null">
                    {{ DateFormat(rowData.dt_pagto_erp) }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="rowData.status_envio_integracao.valor == 1"
                    >{{ rowData.status_envio_integracao.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.status_envio_integracao.valor == 2"
                    >{{ rowData.status_envio_integracao.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="rowData.status_envio_integracao.valor == 3"
                    >{{ rowData.status_envio_integracao.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          :class="
            !(rowData.fatura_despesa_doc.length > 0) &&
            !showShipmenteDocService &&
            !(rowData.fatura_despesa_trecho.length > 0) &&
            !(rowData.obs != null) &&
            !(rowData.num_fatura_erp != null) &&
            rowData.fatura_despesa_foto.length > 0
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t6' + rowData.fatdes_id + ''"
          v-if="rowData.fatura_despesa_foto.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 2%">N° da foto</th>
                <th style="width: 15%">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.fatura_despesa_foto"
                :key="item.fatura_despesa_foto_id"
              >
                <td>
                  {{ i + 1 }}
                </td>
                <td>
                  <a
                    @click="goLink(item.url_foto)"
                    target="_blank"
                    onMouseOver="this.style.color='#404E67'"
                    onMouseOut="this.style.color='#0097e6'"
                  >
                    <span v-if="item.nome_foto != null">
                      {{ item.nome_foto }}
                    </span>
                    <span v-if="item.nome_foto == null">
                      {{ item.url }}
                    </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          role="tabpanel"
          :class="
            !(rowData.fatura_despesa_doc.length > 0) &&
            !showShipmenteDocService &&
            !(rowData.fatura_despesa_trecho.length > 0) &&
            !(rowData.obs != null) &&
            !(rowData.num_fatura_erp != null) &&
            !(rowData.fatura_despesa_foto.length > 0) &&
            rowData.motivo_rejeicao != null
              ? 'tab-pane fade in active show'
              : 'tab-pane fade'
          "
          v-bind:id="'t7' + rowData.fatdes_id + ''"
          v-if="rowData.motivo_rejeicao != null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 25%">Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.motivo_rejeicao != null">
                    {{ rowData.motivo_rejeicao }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      featureFlag: true,
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },

  computed: {
    showShipmenteDocService: function () {
      return this.featureFlag && this.rowData.carga_doc_servico.length > 0;
    }
  },

  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function(date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    goLink(data) {
      window.open(data, "_blank");
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
  },
};
</script>
